var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var CircleAlertIcon = function CircleAlertIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1755 2048' }),
    React.createElement('path', { d: 'M0 877q0-179 69.5-341.5t187-279.5 280-186.5T878 0t341.5 69.5T1499 256t186.5 279.5T1755 877t-69.5 341.5-186.5 280-279.5 187T878 1755t-341.5-69.5-280-187-187-280T0 877zm779 398q0 48 30 72 29 26 70 26 39 0 68-26 30-27 30-72 0-40-30-70-30-28-69-28-41 0-71 28-28 30-28 70zm0-778q0 58 6 131l21 314q5 60 19 91 14 29 49 29 37 0 51-30 15-34 19-88l29-324q4-60 4-87 0-75-19-113-20-39-76-39-47 0-75 31-28 33-28 85z' })
  );
};
export default CircleAlertIcon;